import gql from 'graphql-tag';

export const DELETE_CODE_ASSET = gql`
  mutation deleteAsset($assetId: String!) {
    asset {
      deleteAsset(assetId: $assetId)
    }
  }
`;
